import { css } from '@emotion/react';

import * as React from 'react';
import { useEffect } from 'react';

import { Avatar, Grid, Typography, Typography2 } from '@coursera/cds-core';

import { HidePii } from 'bundles/admin-shared/components/HidePii';

import { StaffPermissionsLoadingEventName } from '../types/eventingTypes';
import { trackLoadingTime } from '../utils/eventingUtils';
import { useStaffPermissionsEventing } from './StaffPermissionsEventing';

const styles = {
  root: () => css`
    margin-bottom: var(--cds-spacing-600);
  `,
  infoContainer: () => css`
    margin-left: var(--cds-spacing-200);
  `,
};

interface Props {
  email: string | null | undefined;
  fullName: string | null | undefined;
  profilePicture: string | null | undefined;
  timezoneName: string | null | undefined;
}

const UserCard = ({ email, fullName, profilePicture, timezoneName }: Props) => {
  const { eventData, targetUserId, staffPermissionsViewLoadedTime } = useStaffPermissionsEventing();

  useEffect(() => {
    if (!!eventData && !!staffPermissionsViewLoadedTime && !!targetUserId) {
      trackLoadingTime(
        eventData,
        Date.now() - staffPermissionsViewLoadedTime,
        Number(targetUserId),
        StaffPermissionsLoadingEventName.UserProfile
      );
    }
    // the side effect of eventing is intended to be executed only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let emailAndTimezoneStr = '';
  if (!!email && !!timezoneName) {
    emailAndTimezoneStr = `${email} · ${timezoneName}`;
  } else if (email) {
    emailAndTimezoneStr = email;
  } else if (timezoneName) {
    emailAndTimezoneStr = timezoneName;
  }

  return (
    <HidePii>
      <Grid container alignItems="center" css={styles.root}>
        {!!fullName && (
          <div>
            <Avatar
              variant="user"
              initial={fullName[0]}
              imgProps={{
                src: profilePicture || undefined,
              }}
              size={64}
              showBorder
            />
          </div>
        )}
        <Grid item css={styles.infoContainer}>
          {!!fullName && (
            <Typography component="p" variant="h1semibold">
              {fullName}
            </Typography>
          )}
          {!!emailAndTimezoneStr && (
            <Typography2 component="p" variant="bodyPrimary" color="supportText">
              {emailAndTimezoneStr}
            </Typography2>
          )}
        </Grid>
      </Grid>
    </HidePii>
  );
};

export default UserCard;
